import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import './App.scss';
import Loading from './components/atoms/loading/loading';
import AccessDenied from './components/views/access-denied';
import AnonymousLayout from './components/views/layout/anonymous/anonymous';
import MainLayout from './components/views/layout/main/main';
import { ROUTE_PATHS } from './constants/url-config';
import { AppState } from './redux/store';
import { anonymousRouters, authorizedRouters } from './routing';
import HISTORY from './utils/history.helper';
import { PERMISSION, ROLE_GUARD } from './utils/role-guard';

import {
	BarController, BarElement, CategoryScale, Chart, Decimation, Filler,
	Legend, LinearScale, LineController, LineElement, PointElement, Title,
	Tooltip
} from 'chart.js';

Chart.register(
	LineElement,
	BarElement,
	PointElement,
	BarController,
	LineController,
	CategoryScale,
	LinearScale,
	Decimation,
	Filler,
	Legend,
	Title,
	Tooltip
);

function App() {

	const userState = useSelector((state: AppState) => state.userState);

	const permissionDenied = (expectedPermissions?: PERMISSION[]) => {
		return expectedPermissions && expectedPermissions.length > 0 && !ROLE_GUARD.hasPermission(expectedPermissions)
	}

	return (
		<div className="App">
			<Loading />

			<Router history={HISTORY}>
				<Switch>

					{
						anonymousRouters.filter(p => p.component).map(({ href, component: Component, exact }) => (
							<Route
								key={href}
								path={href}
								exact={exact}
								render={(props) => <AnonymousLayout>
									<Component {...props} />
								</AnonymousLayout>}
							/>
						))
					}

					<Route>
						<MainLayout>
							<Switch>
								{authorizedRouters.filter(p => p.component).map(({ href, exact, component: Component, permissions, loginRequired, title, hideBreadcrumb, id }) => (
									<Route
										key={id}
										path={href}
										exact
										render={(props) =>
											!userState.isLoggined && loginRequired ? <Redirect to={ROUTE_PATHS.SignIn} /> :
												permissionDenied(permissions) ? <AccessDenied /> : <Component {...props}
												/>}
									/>
								))}

								<Redirect to={ROUTE_PATHS.Home} />
							</Switch>

						</MainLayout>
					</Route>
				</Switch>
			</Router>


		</div>
	)
}

export default App;
